import { render, staticRenderFns } from "./QuestionnaireEditSectionTableConfigureDialog.vue?vue&type=template&id=727df71e"
import script from "./QuestionnaireEditSectionTableConfigureDialog.vue?vue&type=script&lang=js"
export * from "./QuestionnaireEditSectionTableConfigureDialog.vue?vue&type=script&lang=js"
import style0 from "./QuestionnaireEditSectionTableConfigureDialog.vue?vue&type=style&index=0&id=727df71e&prod&lang=stylus&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports